import { FormField, Input } from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';

/**
 * A form field component of input with validation
 * @param {*} props
 * @returns
 */
export default function InputWithValidation(props) {
    // required form field props
    const formFieldProps = {
        label: props.label,
        description: props.description,
        errorText: props.errorText,
    };

    // optional form field props
    if (props.constraintText) {
        formFieldProps.constraintText = props.constraintText;
    }

    return (
        <FormField {...formFieldProps}>
            <Input
                placeholder={props.placeholder}
                value={props.value}
                type={props.type}
                onChange={(event) => {
                    props.setValue(event.detail.value);
                    props.setError('');
                }}
            />
        </FormField>
    );
}
